module.exports = __webpack_public_path__ + "static/media/mute_club_1.abaa6b0e.png";